/* ------------------------------------------------------------------
   v2 quick add: the shared size picker behind every product card's
   "Add to cart" button for a product with more than one variant.

   Markup: snippets/v2-quick-add.liquid (rendered once by the layout).
   Trigger: snippets/v2-add-button.liquid, a [data-v2qa-open] button with a
   [data-v2qa-product] JSON script right beside it.

   Phones get a bottom sheet, desktop a popover beside the button, and a
   card that is itself inside a dialog (the quiz popup) gets a centred
   dialog, because its button is about to disappear.

   The add goes to assets/cs-card-added.js (5 October 2026), the same as a
   one-variant card: /cart/add.js, the card shows it is in the bag, a toast
   offers Undo and View bag, and no drawer opens. The <product-form> submit
   is the fallback if that file is missing: the drawer opens, and the picker
   closes when that add is published as a cart update.
   ------------------------------------------------------------------ */

(function () {
  var root = document.getElementById('v2qa');
  if (!root) return;

  var panel = root.querySelector('.v2qa__panel');
  var optionsEl = root.querySelector('[data-v2qa-options]');
  var titleEl = root.querySelector('[data-v2qa-title]');
  var priceEl = root.querySelector('[data-v2qa-price]');
  var imgEl = root.querySelector('[data-v2qa-img]');
  var hintEl = root.querySelector('[data-v2qa-hint]');
  var form = root.querySelector('product-form form');
  var idInput = form.querySelector('[name="id"]');
  var submit = form.querySelector('[type="submit"]');
  var label = submit.querySelector('span');
  var errorWrap = root.querySelector('.product-form__error-message-wrapper');
  var phone = window.matchMedia('(max-width: 749px)');

  var product = null;
  var selected = [];
  var trigger = null;
  var isOpen = false;

  function productFor(btn) {
    var holder = btn.nextElementSibling;
    if (!holder || !holder.hasAttribute('data-v2qa-product')) {
      holder = btn.parentNode.querySelector('[data-v2qa-product]');
    }
    if (!holder) return null;
    try {
      return JSON.parse(holder.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Variants consistent with a partial selection, where null means any. */
  function matching(values) {
    return product.variants.filter(function (v) {
      return values.every(function (val, i) {
        return val === null || v.options[i] === val;
      });
    });
  }

  function firstMissing() {
    for (var i = 0; i < selected.length; i++) {
      if (selected[i] === null) return i;
    }
    return -1;
  }

  function build() {
    optionsEl.textContent = '';
    product.options.forEach(function (opt, i) {
      var group = document.createElement('div');
      group.className = 'v2qa__group';

      var name = document.createElement('p');
      name.className = 'v2qa__name';
      name.id = 'v2qa-opt-' + i;
      name.textContent = opt.name;

      var pills = document.createElement('div');
      pills.className = 'v2qa__pills';
      pills.setAttribute('role', 'group');
      pills.setAttribute('aria-labelledby', name.id);

      opt.values.forEach(function (value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'v2qa__pill';
        b.textContent = value;
        b.setAttribute('data-index', i);
        b.setAttribute('data-value', value);
        pills.appendChild(b);
      });

      group.appendChild(name);
      group.appendChild(pills);
      optionsEl.appendChild(group);
    });
    update();
  }

  function update() {
    Array.prototype.forEach.call(optionsEl.querySelectorAll('.v2qa__pill'), function (b) {
      var i = parseInt(b.getAttribute('data-index'), 10);
      var value = b.getAttribute('data-value');
      var trial = selected.slice();
      trial[i] = value;
      var buyable = matching(trial).some(function (v) { return v.available; });
      b.setAttribute('aria-pressed', selected[i] === value ? 'true' : 'false');
      b.classList.toggle('is-unavailable', !buyable);
      if (buyable) b.removeAttribute('aria-label');
      else b.setAttribute('aria-label', value + ', sold out');
    });

    var missing = firstMissing();
    var variant = missing === -1 ? matching(selected)[0] || null : null;

    if (variant && variant.available) {
      idInput.value = variant.id;
      submit.removeAttribute('aria-disabled');
      label.textContent = 'Add to cart';
      priceEl.textContent = variant.price;
      hintEl.textContent = '';
    } else {
      idInput.value = '';
      submit.setAttribute('aria-disabled', 'true');
      if (variant) {
        label.textContent = 'Sold out';
        priceEl.textContent = variant.price;
        hintEl.textContent = '';
      } else {
        label.textContent = 'Add to cart';
        priceEl.textContent = product.price;
        hintEl.textContent =
          missing === -1 ? '' : 'Choose a ' + String(product.options[missing].name).toLowerCase();
      }
    }
  }

  /* Popover beside the button on desktop; otherwise the CSS default, a
     bottom sheet on phones and a centred dialog above that. */
  function place() {
    if (!isOpen) return;
    var pop = !phone.matches && trigger && trigger.isConnected && !trigger.closest('[role="dialog"]');
    root.classList.toggle('v2qa--pop', !!pop);
    document.documentElement.classList.toggle('v2qa-lock', !pop);
    if (!pop) {
      panel.style.left = '';
      panel.style.top = '';
      return;
    }
    var GAP = 10;
    var EDGE = 16;
    var r = trigger.getBoundingClientRect();
    var w = panel.offsetWidth;
    var h = panel.offsetHeight;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var left = Math.min(Math.max(r.left + r.width / 2 - w / 2, EDGE), vw - w - EDGE);
    var top = r.top - h - GAP;
    if (top < EDGE) top = r.bottom + GAP;
    if (top + h > vh - EDGE) top = Math.max(EDGE, vh - h - EDGE);
    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(top) + 'px';
  }

  function open(btn) {
    var data = productFor(btn);
    if (!data || !data.variants || !data.variants.length) return;
    product = data;
    trigger = btn;
    selected = product.options.map(function (opt) {
      return opt.values.length === 1 ? opt.values[0] : null;
    });

    titleEl.textContent = product.title;
    if (product.image) {
      imgEl.src = product.image;
      imgEl.hidden = false;
    } else {
      imgEl.removeAttribute('src');
      imgEl.hidden = true;
    }
    if (errorWrap) errorWrap.hidden = true;
    build();

    isOpen = true;
    root.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    place();

    var missing = firstMissing();
    var focusTarget = missing === -1
      ? submit
      : optionsEl.querySelectorAll('.v2qa__pills')[missing].querySelector('.v2qa__pill');
    (focusTarget || panel).focus({ preventScroll: true });
  }

  function close(returnFocus) {
    if (!isOpen) return;
    isOpen = false;
    root.hidden = true;
    root.classList.remove('v2qa--pop');
    document.documentElement.classList.remove('v2qa-lock');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus !== false && trigger.isConnected) trigger.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var btn = target.closest('[data-v2qa-open]');
    if (btn) {
      e.preventDefault();
      if (isOpen && trigger === btn) {
        close();
      } else {
        close(false);
        open(btn);
      }
      return;
    }
    if (!isOpen) return;

    if (target.closest('[data-v2qa-close]')) {
      close();
      return;
    }
    var pill = target.closest('.v2qa__pill');
    if (pill && root.contains(pill)) {
      selected[parseInt(pill.getAttribute('data-index'), 10)] = pill.getAttribute('data-value');
      update();
      place();
    }
  });

  /* A complete choice goes to the shared added state. Caught on the way
     down, so product-form.js never sees it. */
  root.addEventListener('submit', function (e) {
    if (e.target !== form || submit.getAttribute('aria-disabled') === 'true' || !window.csAdded) return;
    e.preventDefault();
    e.stopPropagation();
    var card = trigger && trigger.closest('[data-csa-card]');
    window.csAdded.add(idInput.value, {
      card: card,
      button: submit,
      name: product && product.title,
      image: product && product.image
    }).then(function (line) {
      if (line) {
        close(false);
        var remove = card && card.querySelector('[data-csa-remove]');
        if (remove) remove.focus({ preventScroll: true });
        return;
      }
      if (errorWrap) {
        var msg = errorWrap.querySelector('.product-form__error-message');
        if (msg) msg.textContent = 'Could not add this to your bag. Please try again.';
        errorWrap.hidden = false;
      }
    });
  }, true);

  /* A submit before every choice is made goes to the first missing choice
     instead. product-form.js ignores the submit itself while aria-disabled. */
  form.addEventListener('submit', function (e) {
    if (submit.getAttribute('aria-disabled') !== 'true') return;
    e.preventDefault();
    var missing = firstMissing();
    if (missing === -1) return;
    var pill = optionsEl.querySelectorAll('.v2qa__pills')[missing].querySelector('.v2qa__pill');
    if (pill) pill.focus();
  });

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('button, a[href]'), function (el) {
      return !el.disabled && el.getClientRects().length > 0;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var at = items.indexOf(document.activeElement);
    if (e.shiftKey && at <= 0) {
      e.preventDefault();
      items[items.length - 1].focus();
    } else if (!e.shiftKey && (at === -1 || at === items.length - 1)) {
      e.preventDefault();
      items[0].focus();
    }
  });

  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true });
  if (phone.addEventListener) phone.addEventListener('change', place);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (!isOpen || !evt || evt.source !== 'product-form') return;
      if (String(evt.productVariantId) !== String(idInput.value)) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && trigger && typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(trigger);
      }
      close(false);
    });
  }
})();
